import { render, staticRenderFns } from "./TimeSendingInterval.vue?vue&type=template&id=ec6a9840&scoped=true"
import script from "./TimeSendingInterval.vue?vue&type=script&lang=js"
export * from "./TimeSendingInterval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6a9840",
  null
  
)

export default component.exports